import { Component } from '@angular/core';

/**
 * Demonstrate the usage of {@link PanelComponent}
 */
@Component({
  templateUrl: './panel-demo.component.html',
  styleUrls: ['./panel-demo.component.scss'],
})
export class PanelDemoComponent {
}



// WEBPACK FOOTER //
// ./src/app/panel/panel-demo.component.ts